module.exports = __webpack_public_path__ + "static/site-3e3eaca12ef3b481e63024a997fdfcc9.jpg";